import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.for-each.js";
import { ElMessage, ElMessageBox, ElNotification } from 'element-plus';
import { handleHttp, setImgsize, sizeFilter } from "@/utils/utils";
let _ = require('lodash');
export default {
  props: {
    // 名称
    name: {
      type: String,
      default: ''
    },
    uploadList: {
      type: Array,
      default: []
    },
    // 宽度
    width: {
      type: Number,
      default: 72
    },
    // 高度
    height: {
      type: Number,
      default: 72
    },
    // 文件限制参数
    field: {
      type: Object,
      default: {
        fieldType: {
          type: 'img'
        },
        verify: {
          limitCount: 0,
          limitHeight: 0,
          limitSize: 0,
          limitType: '',
          limitWidth: 0,
          maxValue: {
            errMsg: '上传个数最大限制',
            range: 1
          },
          minValue: {
            errMsg: '上传个数最小限制',
            range: ''
          }
        }
      }
    },
    styletype: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      defaultupImg: require('@/assets/mapv2/defaultImage.jpg'),
      upImg: require('@/assets/mapv2/defaultImage.jpg'),
      imgsize: 0,
      imgWH: '',
      imglimit: '',
      minValue: 0,
      maxValue: 0,
      accept: '.jpg,.jpeg,.png,.gif',
      fileList: [],
      imgurl: '',
      verify: {},
      multiple: true
    };
  },
  watch: {
    uploadList: {
      handler(val) {
        // console.log('fieldwatch', val)
        // console.log(`this.styletype`, this.styletype);
        // this.imgurl = val.length > 0 ? setImgsize(val[0], this.width, this.height) : ''
        // if (this.imgurl === '') this.upImg = this.defaultupImg
        // this.fileList = val
        if (val.length > 0) {
          this.fileList = _.cloneDeep(val);
          // if (this.fileList[0].fileUrl && this.fileList[0].fileUrl.includes('data:image')) {
          //   this.imgurl = this.fileList[0].fileUrl
          // } else {
          //   this.imgurl = this.fileList[0].fileUrl
          // }
          console.log(`this.fileList`, this.fileList);
          this.imgurl = this.fileList[0].fileUrl || this.fileList[0].http;
        } else {
          this.imgurl = '';
          this.upImg = this.defaultupImg;
        }
      },
      deep: true
    }
  },
  mounted() {
    this.$nextTick(() => {
      if (Object.keys(this.field).length === 0) return;
      this.init();
    });
  },
  methods: {
    init() {
      this.verify = this.field.verify;
      // console.log(this.field);
      // 图片类型判断
      if (this.verify.limitType !== '') {
        if (this.verify.limitType.includes(';')) {
          let typeArr = this.verify.limitType.split(';');
          let accept = [];
          typeArr.forEach(item => {
            accept.push(`.${item}`);
          });
          this.accept = accept.join(',');
        } else {
          this.accept = `.${this.verify.limitType}`;
        }
      } else {
        let defaultaccept = '.jpg,.jpeg,.png,.gif';
        if (this.field.fieldType.type === 'file') defaultaccept = '.mp3';
        if (this.field.fieldType.type === 'video') defaultaccept = '.mp4';
        this.accept = defaultaccept;
      }
      // console.log(`${this.name}:${this.accept}`);
      // 图片大小判断
      if (this.verify.limitSize > 0) this.imgsize = this.verify.limitSize;
      // 图片宽高判断
      if (this.verify.limitWidth > 0 && this.verify.limitHeight > 0) this.imgWH = `${this.verify.limitWidth}*${this.verify.limitHeight}`;
      // 图片个数判断
      let maxValue = '';
      let minValue = '';
      if (this.verify.minValue.range !== '') {
        minValue = `${this.verify.minValue.errMsg}${this.verify.minValue.range}张`;
        this.minValue = Number(this.verify.minValue.range);
      }
      if (this.verify.maxValue.range !== '') {
        maxValue = `${this.verify.maxValue.errMsg}${this.verify.maxValue.range}张`;
        this.maxValue = Number(this.verify.maxValue.range);
      }
      this.imglimit = `${minValue}${maxValue}`;
      if (this.maxValue > 0 || this.minValue > 0) this.multiple = false;
      // console.log('fieldname', this.name)
      // console.log(`this.uploadList`, this.uploadList);
      if (this.uploadList.length > 0) {
        this.fileList = _.cloneDeep(this.uploadList);
        if (this.fileList[0].fileUrl.includes('data:image')) {
          this.imgurl = this.fileList[0].fileUrl;
        } else {
          this.imgurl = setImgsize(this.fileList[0], this.width, this.height);
        }
      }
    },
    fileChangeHandle(e) {
      let that = this;
      // console.log(e);
      // console.log(this.fileList.length);
      // console.log(this.maxValue);
      // 处理最大上传个数限制
      if (this.fileList.length >= this.maxValue && this.maxValue !== 0 && this.styletype === 3) {
        ElMessage({
          message: this.imglimit,
          type: 'warning'
        });
        return false;
      }
      let files = e.target.files;
      // console.log(files);
      files.forEach(item => {
        let formData = new FormData();
        formData.append('file', item);
        formData.append('_uid', this.$route.query.uid);
        formData.append('fid', this.$route.query.fid);
        this.$api.uploadSingle(formData).then(res => {
          console.log(res);
          // 处理图片大小限制
          let size = Number((res.size / 1024 / 1024).toFixed(2));
          if (that.imgsize !== 0 && size > that.imgsize) {
            ElMessage({
              message: this.imglimit,
              type: 'warning'
            });
            return false;
          }
          if (that.verify.limitWidth > 0 && that.verify.limitHeight > 0) {
            var img = new Image();
            img.src = res.http;
            img.onload = function () {
              if (img.width !== that.verify.limitWidth && img.height !== that.verify.limitHeight) {
                ElMessage({
                  message: `请上传${that.imgWH}图片`,
                  type: 'warning'
                });
                return false;
              }
              that.addList(res);
            };
            return false;
          }
          that.addList(res);
        });
      });
    },
    addList(res) {
      console.log(this.styletype);
      let obj = {
        ...res
      };
      obj.suffix = obj.name.split('.')[1];
      obj.http = handleHttp(obj.http);
      // console.log(obj)
      this.upImg = obj.http;
      if (this.styletype === 1) {
        this.fileList = [obj];
      } else {
        this.fileList.push(obj);
      }
      // console.log(this.fileList);
      this.$emit('fileList', this.fileList);
    },
    /**
     * 删除操作
     */
    deleteHandle(item) {
      console.log(item);
      let that = this;
      ElMessageBox.confirm('确定要删除么？', '温馨提示', {
        distinguishCancelAndClose: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        console.log(that.fileList);
        that.fileList = that.fileList.filter(child => {
          return !(child.objectid === item.objectid) || !(child.objectId === item.objectId);
        });
        console.log(that.fileList);
        if (that.fileList.length === 0) {
          that.imgurl = '';
          that.upImg = that.defaultupImg;
        }
        that.$emit('fileList', that.fileList);
      }).catch(() => {});
    }
  }
};